import {
  LIST_EXPENSE_TABLES,
  CREATE_EXPENSE_TABLE,
  UPDATE_EXPENSE_TABLE,
} from '@/data/actions/modules/general';

export default [
  {
    path: '/clinical/expense-tables',
    component: () => import(/* webpackChunkName: "tables" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_EXPENSE_TABLES,
    },
  },
  {
    path: '/clinical/expense-tables/create',
    component: () => import(/* webpackChunkName: "tables" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: CREATE_EXPENSE_TABLE,
    },
  },
  {
    path: '/clinical/expense-tables/:id/edit',
    component: () => import(/* webpackChunkName: "tables" */ './components/Form.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: UPDATE_EXPENSE_TABLE,
    },
  },
];
